import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { checkCustomerPoUnique, getSaleOrderDetails } from "../../../api/pagination";
import { getDistributorStock } from "../../../api/edi.api";
import { createAdminNotification } from "../../../utils/notificationService";
import { capturePaymentAPI } from "../../../api/payment.api";
import { sentNoteToCustomer } from "../../../api/sendEmailPdf.api";
import {
  orderStatuses,
  returnStatus,
  returnStatusShip
} from "../../../data";
import {
  addToArray,
  generateCustomID,
  saveData,
  uniqueID,
  uploadingImages,
} from "../../../firebase/utility";
import { normalizeStatusValue } from "../../../utils/normalizeStatusValue";

const useSalesOrderDetails = () => {
  // ================== HOOKS & REDUX ==================
  const history = useHistory();
  const { state } = useLocation();

  const { id } = useParams();

  const { all_products } = useSelector((state) => state.products);
  const { user } = useSelector((state) => state.auth);
  const { all_purchase_orders, all_vendors } = useSelector(
    (state) => state.orders
  );




  // ================== STATES ==================
  const [viewers, setViewers] = useState([]);
  const [presenceStop, setPresenceStop] = useState(null);


  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [orderData, setOrderData] = useState(state ?? {});

  const [customer_acc, setCustomerAcc] = useState("");
  const [returnOrders, setReturnOrders] = useState([]);
  const [orderLabels, setOrderLabels] = useState([]);
  const [returnVendor, setReturnVendor] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [noteloader, setNoteLoader] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const [captureLoading, setCaptureLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  const [creationDate, setCreationDate] = useState(
    moment(state?.date_created).format("YYYY-MM-DD") ?? ""
  );
  const [orderCritical, setOrderCritical] = useState(orderData?.orderCritical ?? false);
  const [stockData, setStockData] = useState([]);
  const [distributorStockLoading, setDistributorStockLoading] = useState(false);
  const [note, setNote] = useState("");
  const [totalAmount, setTotalAmount] = useState(orderData?.total ?? 0);
  const [invoices, setInvoices] = useState([]);
  const [orderNotes, setOrderNotes] = useState(orderData?.logs ?? []);
  const [subTotal, setSubTotal] = useState(orderData?.subTotal ?? 0);
  const [billingData, setBillingData] = useState(state?.billing ?? {});
  const [shippingData, setShippingData] = useState(state?.shipping ?? {});
  const [orderNumber, setOrderNumber] = useState(orderData?.number ?? "");
  const [totalTax, setTotalTax] = useState(0);
  const [selectedOrdersIds, setSelectedOrdersIds] = useState([]);
  const [line_items, setLineItems] = useState(orderData?.line_items ?? []);

  const [new_line_items, setNewLineItems] = useState([]);
  const [poDetails, setPoDetails] = useState([]);

  const [totalTaxAmount, setTotalTaxAmount] = useState({
    shippingAmount: orderData?.totalTaxAmount?.shippingAmount ?? 0,
    insurance: orderData?.totalTaxAmount?.insurance ?? 0,
    discount: orderData?.totalTaxAmount?.discount ?? 0,
    tax: orderData?.totalTaxAmount?.tax ?? 0,
  });

  // ================== CHECKBOXES ==================
  const [shippingCheckboxes, setShippingCheckboxes] = useState(
    orderData?.shippingCheckboxes ?? {
      sms_disabled: false,
      residiential: false,
      do_not_email: false,
      ship_partially: false,
    }
  );

  // ================== MODALS ==================
  const [itemModal, setItemModal] = useState(false);
  const toggleItemModal = () => setItemModal(!itemModal);

  const [creditCardModal, setcreditCardModal] = useState(false);
  const togglecreditCardModal = () => setcreditCardModal(!creditCardModal);

  const [purchaseOrderModal, setpurchaseOrderModal] = useState(false);
  const togglepurchaseOrderModal = () => setpurchaseOrderModal(!purchaseOrderModal);

  const [shippingModal, setShippingModal] = useState(false);
  const toggleShippingModal = () => setShippingModal(!shippingModal);

  const [packageSlipModal, setPackageSlipModal] = useState(false);
  const togglePackageSlipModal = () => setPackageSlipModal(!packageSlipModal);

  const [inoiceModal, setInvoiceModal] = useState(false);
  const toggleInvoiceModal = () => setInvoiceModal(!inoiceModal);

  // ================== SELECTS ==================
  const [orderStatus, setOrderStatus] = useState(
    orderStatuses.find((i) => i.label === orderData?.status)?.label ?? ""
  );
  const [paymentStatus, setPaymentStatus] = useState(
    normalizeStatusValue(orderData?.paymentStatus) || "Pending Payment"
  );
  const [return_status, set_return_status] = useState(
    returnStatus.find((i) => i.value === orderData?.return_status)?.value ?? ""
  );
  const [shipBy, setShipBy] = useState(
    returnStatusShip.find((i) => i.value === orderData?.shipBy)?.value ?? ""
  );

  // ================== FUNCTIONS ==================
  const calculateTotal = useCallback(() => {
    const sub = parseFloat(
      subTotal?.toString().replace(/[^0-9.-]+/g, "") || 0
    );
    const taxRate = parseFloat(
      totalTaxAmount?.tax?.toString().replace(/[^0-9.-]+/g, "") || 0
    );
    const shipping = parseFloat(
      totalTaxAmount?.shippingAmount?.toString().replace(/[^0-9.-]+/g, "") || 0
    );
    const insurance = parseFloat(
      totalTaxAmount?.insurance?.toString().replace(/[^0-9.-]+/g, "") || 0
    );
    const discount = parseFloat(
      totalTaxAmount?.discount?.toString().replace(/[^0-9.-]+/g, "") || 0
    );

    const taxAmount = (sub / 100) * taxRate;
    const finalTotal = sub + taxAmount + shipping + insurance - discount;

    setTotalAmount(finalTotal.toFixed(2));
    setTotalTax(taxAmount.toFixed(2));
  }, [subTotal, totalTaxAmount]);

  const mapOrderResponse = useCallback((data) => {
    console.log('data', data?.saleOrder)
    setOrderData(data?.saleOrder);
    setReturnOrders(data?.returns ?? []);
    setPoDetails(data?.purchaseOrders ?? []);
    setOrderLabels(data?.trackings ?? []);
    setOrderNotes(data?.saleOrder?.logs);
    setOrderStatus(data?.saleOrder?.status);
    setPaymentStatus(
      normalizeStatusValue(data?.saleOrder?.paymentStatus) || "Pending Payment"
    );
    setShipBy(data?.saleOrder?.shipBy);
    setLineItems(data?.saleOrder?.line_items ?? []);
    setCreationDate(moment(data?.saleOrder?.date_created).format("YYYY-MM-DD"));
    setOrderNumber(data?.saleOrder?.number ?? "");
    setCustomerAcc(data?.saleOrder?.customer_acc ?? "");
    setBillingData(data?.saleOrder?.billing ?? {});
    setShippingData(data?.saleOrder?.shipping ?? {});
    setShippingCheckboxes(data?.saleOrder?.shippingCheckboxes ?? {});
    setOrderCritical(data?.saleOrder?.orderCritical ?? false);
    setTotalTaxAmount({
      shippingAmount: parseFloat(data?.saleOrder?.totalTaxAmount?.shippingAmount || 0),
      insurance: parseFloat(data?.saleOrder?.totalTaxAmount?.insurance || 0),
      discount: parseFloat(data?.saleOrder?.totalTaxAmount?.discount || 0),
      tax: parseFloat(data?.saleOrder?.totalTaxAmount?.tax || 0),
    });
    setSubTotal(data?.saleOrder?.subTotal ?? 0);
    setTotalAmount(data?.saleOrder?.total ?? 0);
    setStockData([
      ...(data?.ownStock || []),
      ...(data?.dnhProducts || []),
      ...(data?.ingramProducts || [])
    ]);
    setDataLoading(false);
  }, []);

  const handleSubmitOrder = async () => {
    setLoader(true);

    if (!shipBy) {
      toast.error("Please select ship by to proceed !");
      setLoader(false);
      return;
    }

    let finalLineItems;
    if (line_items?.length > 0) {
      let arr = await uploadingImages(line_items ?? [], "sale_orders");
      finalLineItems = line_items.map((item, index) => ({
        ...item,
        quickbooks_id: item.quickbooks_id ?? "",
        image: { src: arr[index], id: uniqueID() },
      }));
    }

    let userInfo = {
      username: user?.username ?? "",
      email: user?.email ?? "",
      role: user?.role ?? "",
      profileImage: user?.profileImage ?? "",
      phone: user?.phone ?? "",
      address: user?.address ?? "",
      _id: user?._id ?? "",
    };

    const finalPaymentStatus =
      normalizeStatusValue(paymentStatus) ||
      normalizeStatusValue(orderData?.paymentStatus) ||
      "Pending Payment";

    const obj = {
      billing: Object.keys(billingData).length > 0 ? billingData : orderData?.billing,
      shipping: Object.keys(shippingData).length > 0 ? shippingData : orderData?.shipping,
      id: orderData?.id || (await generateCustomID("Orders", "id")),
      number: orderNumber,
      total: totalAmount,
      return_status,
      shipBy: shipBy ?? "",
      subTotal,
      line_items: finalLineItems ?? [],
      totalTaxAmount,
      status: orderStatus ?? "New",
      _id: orderData?._id,
      date_created: orderData?.date_created ?? Date.parse(new Date()),
      shippingCheckboxes: shippingCheckboxes,
      customer_id: shippingData?.quickbooks_id ?? orderData?.customer_id,
      paymentStatus: finalPaymentStatus,
      customer_acc: customer_acc ?? "",
      orderCritical: orderCritical ?? false,
      updatedBy: userInfo ?? {},
    };

    checkCustomerPoUnique(obj?.number, obj?._id, (res) => {
      if (res?.status === 200) {
        saveData("Orders", obj?._id, obj)
          .then(() => {
            setLoader(true);
            refreshSaleOrderDetails();
            toast.success("Order Details Updated Successfully");
            createAdminNotification({
              title: "Sales Order Updated",
              message: `Order #${obj?.number || obj?.id} was updated by ${user?.username || "Admin"}`,
              category: "order",
              entityId: String(obj?.number || obj?.id),
              targetUrl: `/admin/sale-order-details/${obj?.id || id}`,
              actor: user,
            }).catch(console.error);
          })
          .catch(() => {
            toast.error("Failed to update order");
            setLoader(false);
          });
      } else {
        toast.error(res?.message ?? "Failed to update order");
        setLoader(false);
      }
    });
  };

  const addOrderNote = async () => {
    if (note.trim() === "") {
      toast.error("Please add note to proceed!");
      return;
    }

    const noteObj = {
      id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      createdAt: Date.now(),
      createdBy: {
        _id: user?._id || "",
        username: user?.username || "",
        email: user?.email || "",
        role: user?.role || "",
        profileImage: user?.profileImage || "",
        phone: user?.phone || "",
        address: user?.address || "",
      },
      message: note.trim(),
      personalNote: true,
    };

    try {
      await addToArray("Orders", orderData?._id, "logs", noteObj);
      setOrderNotes((prev) => [...prev, noteObj]);
      setNote("");
      toast.success("Note added!");
    } catch (error) {
      console.error("Failed to add note:", error);
      toast.error("Failed to add note");
    }
  };

  const deleteOrderNote = async (noteObj) => {
    try {
      await firebase
        .firestore()
        .collection("Orders")
        .doc(orderData?._id)
        .update({
          logs: firebase.firestore.FieldValue.arrayRemove(noteObj),
        });
      setOrderNotes((prev) => prev.filter((item) => item.id !== noteObj.id));
      toast.success("Note deleted successfully!");
    } catch (error) {
      console.error("Failed to delete note:", error);
      toast.error("Failed to delete note");
    }
  };

  const updateOrderNote = async (oldNoteObj, newMessage) => {
    if (newMessage.trim() === "") {
      toast.error("Note cannot be empty!");
      return;
    }

    const updatedNoteObj = {
      ...oldNoteObj,
      message: newMessage.trim(),
      updatedAt: Date.now(),
      updatedBy: {
        _id: user?._id || "",
        username: user?.username || "",
      },
    };

    try {
      const docRef = firebase.firestore().collection("Orders").doc(orderData?._id);
      await docRef.update({
        logs: firebase.firestore.FieldValue.arrayRemove(oldNoteObj),
      });
      await docRef.update({
        logs: firebase.firestore.FieldValue.arrayUnion(updatedNoteObj),
      });

      setOrderNotes((prev) =>
        prev.map((item) => (item.id === oldNoteObj.id ? updatedNoteObj : item))
      );
      toast.success("Note updated successfully!");
    } catch (error) {
      console.error("Failed to update note:", error);
      toast.error("Failed to update note");
    }
  };


  const returnOrder = (vendor) => {
    // Helper function to create a normalized representation of line items
    const normalizeLineItems = (items) => {
      if (!items || items.length === 0) return '';
      return items
        .map(item => `${item.sku}:${item.quantity}`)
        .sort()
        .join('|');
    };

    // Check for duplicate return orders
    const currentItemsKey = normalizeLineItems(orderData?.line_items || []);

    if (currentItemsKey && returnOrders && returnOrders.length > 0) {
      const hasDuplicate = returnOrders.some(existingReturn => {
        const returnItemsKey = normalizeLineItems(existingReturn?.line_items || []);
        return currentItemsKey === returnItemsKey;
      });

      if (hasDuplicate) {
        toast.error("A return order with the same items and quantities already exists for this sale order. Please edit the existing return order instead of creating a duplicate.");
        return;
      }
    }

    // No duplicate found, proceed with creating new return order
    let data = {
      ...orderData,
      billing: orderData?.shipping,
      vendor: vendor?.billing[0],
      saleOrderId: orderData?._id
    };

    history.push({
      pathname: `/admin/return-order-details/${orderData?._id}`,
      state: { order: data, isEdit: false },
    });
  };

  const sendNoteToCustomer = () => {
    let data = { orderId: orderData?._id, note: note };

    if (!orderData?._id && !note) {
      toast.error("Please provide order ID and note to send");
      return;
    } else {
      setNoteLoader(true);
      sentNoteToCustomer(data, (res) => {
        if (res?.status === 200) {
          setNote("");
          setNoteLoader(false);
          toast.success("Note sent to customer successfully");
        } else {
          toast.error("Failed to send note to customer");
          setNoteLoader(false);
        }
      });
    }
  };

  const handleCapturePayment = () => {
    setCaptureLoading(true);
    capturePaymentAPI(orderData?._id, (res) => {
      if (res?.status === 200) {
        toast.success("Payment captured successfully");
        createAdminNotification({
          title: "Payment Captured",
          message: `Payment captured for Order #${orderData?.number || orderData?.id} by ${user?.username || "Admin"}`,
          category: "order",
          entityId: String(orderData?.number || orderData?.id),
          targetUrl: `/admin/sale-order-details/${orderData?.id || id}`,
          actor: user,
        }).catch(console.error);
      } else {
        toast.error(res?.message ?? "Failed to capture payment");
      }
    }).finally(() => {
      setCaptureLoading(false);
    });
  };

  const fetchDistributorStockForItems = useCallback((items, fallbackData = null) => {
    if (!items || items.length === 0) {
      setDistributorStockLoading(false);
      if (fallbackData) {
        setStockData([...(fallbackData?.ownStock || []), ...(fallbackData?.dnhProducts || []), ...(fallbackData?.ingramProducts || [])] ?? []);
      } else {
        setStockData([]);
      }
      return;
    }

    const skus = items
      .map((item) => item?.sku || item?.parts)
      .filter(Boolean);

    if (skus.length === 0) {
      setDistributorStockLoading(false);
      setStockData([]);
      return;
    }

    setDistributorStockLoading(true);
    getDistributorStock(skus, (res) => {
      setDistributorStockLoading(false);
      if (res?.status === 200 && res?.data?.data) {
        setStockData(res.data.data);
      } else if (fallbackData) {
        setStockData([...(fallbackData?.ownStock || []), ...(fallbackData?.dnhProducts || []), ...(fallbackData?.ingramProducts || [])] ?? []);
      }
    });
  }, []);

  const refreshSaleOrderDetails = useCallback(() => {
    if (!id) return;
    setDataLoading(true);
    getSaleOrderDetails(id, (res) => {
      if (res?.status !== 200 || !res?.data?.data) {
        setDataLoading(false);
        setLoader(false);
        return;
      }
      const data = res.data.data;
      mapOrderResponse(data);
      setDataLoading(false);
      setLoader(false);

      const items = data?.saleOrder?.line_items || [];
      fetchDistributorStockForItems(items, data);
    });
  }, [id, mapOrderResponse, fetchDistributorStockForItems]);

  // ================== EFFECTS ==================
  useEffect(() => {
    let subtotal = 0;
    line_items?.forEach((item) => {
      const rawQty =
        item.quantity?.toString().replace(/[^0-9.-]+/g, "") || "0";
      const rawPrice =
        item.price?.toString().replace(/[^0-9.-]+/g, "") || "0";
      const quantity = parseInt(rawQty, 10) || 0;
      const price = parseFloat(rawPrice) || 0;
      subtotal += quantity * price;
    });
    setSubTotal(subtotal.toFixed(2));
  }, [line_items]);

  useEffect(() => {
    calculateTotal();
  }, [calculateTotal]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [id]);

  useEffect(() => {
    if (id) refreshSaleOrderDetails();
  }, [id, refreshSaleOrderDetails]);


  useEffect(() => {
    const unsubscribe = firebase
      .firestore()
      .collection("Orders")
      .doc(id)
      .onSnapshot((doc) => {
        if (doc.exists) {
          const currentData = doc.data();
          setOrderStatus(currentData?.status);
          setPaymentStatus(
            normalizeStatusValue(currentData?.paymentStatus) || "Pending Payment"
          );
        }
      });
    return () => unsubscribe();
  }, [id]);





  return {
    toggleItemModal,
    itemModal,
    returnOrder,
    togglecreditCardModal,
    creditCardModal,
    purchaseOrderModal,
    togglepurchaseOrderModal,
    shippingModal,
    toggleShippingModal,
    packageSlipModal,
    togglePackageSlipModal,
    billingData,
    setBillingData,
    shippingData,
    setShippingData,
    orderStatus,
    setOrderStatus,
    paymentStatus,
    setPaymentStatus,
    orderNotes,
    setOrderNotes,
    totalTaxAmount,
    setTotalTaxAmount,
    subTotal,
    totalAmount,
    orderNumber,
    setOrderNumber,
    set_return_status,
    return_status,
    shipBy,
    setShipBy,
    all_products,
    line_items,
    setLineItems,
    note,
    setNote,
    addOrderNote,
    all_vendors,
    shippingCheckboxes,
    setShippingCheckboxes,
    uploadingImages,
    handleSubmitOrder,
    poDetails,
    orderData,
    setOrderData,
    new_line_items,
    setNewLineItems,
    loading,
    totalTax,
    loader,
    creationDate,
    setCreationDate,
    returnVendor,
    setReturnVendor,
    state,
    returnOrders,
    selectedOrdersIds,
    setSelectedOrdersIds,
    orderLabels,
    invoices,
    setInvoices,
    customer_acc,
    setCustomerAcc,
    orderCritical,
    setOrderCritical,
    all_purchase_orders,
    purchaseOrders,
    dataLoading,
    toggleInvoiceModal,
    inoiceModal,
    stockData,
    distributorStockLoading,
    sendNoteToCustomer,
    noteloader,
    handleCapturePayment,
    captureLoading,
    pageLoader,
    refreshSaleOrderDetails,
    viewers,
    deleteOrderNote,
    updateOrderNote
  };
};

export default useSalesOrderDetails;

